import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const POS_SUCCESS = 'POS_SUCCESS';
export const POS_LOADING = 'POS_LOADING';

const { posNew: { getPosNew, deleteAllPosNew } } = apiUrls;


export const getPOSDetailsNew = () => async (dispatch) => {
  try {
// console.log(bodyData)
    const requestData = {
        ...getPosNew,
        url: getPosNew.url,
    };
    const data = await REQUEST(requestData);
    dispatch({
      type: POS_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: POS_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const deleteAllPOSNew = () => async (dispatch) => {
  try {
    dispatch(handleLoader(true));
    const requestData = {
      ...deleteAllPosNew,
      url: deleteAllPosNew.url,
    };
    const data = await REQUEST(requestData);
    if (data && data.code === '200') {
      dispatch({
        type: POS_SUCCESS,
        data,
      });
      return { success: true, data };
    }
    dispatch(handleLoader(false));
    return { success: false, data };
  } catch (e) {
    dispatch(handleLoader(false));
    return { success: false, error: e };
  }
};

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: POS_LOADING,
    isLoading
  })
}
